import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import styled from 'styled-components';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const CustomLink = styled.a`
  text-decoration: none;
  color: #fff;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-item: center;
  margin-top: 50px;
  margin-bottom: 60px;
`;

const IconContainer = styled.div`
  display: flex;
`;

const InformationContainer = styled.div`
  margin-left: 20px;
  margin-top: -15px;
`;

const RotateSquare = styled.div`
  height: 20px;
  width: 20px;
  background-color: ${props => (props.firstElement ? '#7fc7ec' : 'none')};
  border: ${props => (props.firstElement ? 'none' : '1px solid #7fc7ec')};
  transform: rotate(45deg);
`;

const VerticalLine = styled.div`
  border-left: 2px solid #979797;
  height: 70px;
  position: relative;
  left: 9px;
  bottom: 12px;
`;

const Title = styled.h1`
  text-align: center;
  font-weight: 300;
  margin-bottom: 30px;
`;

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(3)
  }
}));

/**
 * Affiche les informations de suivi d'une commande
 * @param {Object} currentCommand Commande actuelle
 */
const Tracking = ({ currentCommand }) => {
  const { commandStatus, finalCarrier, trackingUrl } = currentCommand;
  const classes = useStyles();
  const getUrl = randomId => {
    if (process.env.REACT_APP_STAGE === 'dev') {
      return `https://stage.sympl.fr/shipment/${randomId}`;
    }
    return `https://live.sympl.fr/shipment/${randomId}`;
  };

  return (
    <div className={classes.root}>
      <Title>{finalCarrier && finalCarrier.name}</Title>
      {commandStatus.map((status, index) => (
        <div key={status.created}>
          <IconContainer>
            <RotateSquare firstElement={index === 0} />
            <InformationContainer>
              <div>{status.title}</div>
              <div>{moment(status.created).format('DD/MM/YYYY HH:mm:ss')}</div>
              <div>{status.message}</div>
            </InformationContainer>
          </IconContainer>
          {commandStatus.length - 1 === index ? null : (
            <VerticalLine firstElement={index === 0} />
          )}
        </div>
      ))}
      <ButtonContainer>
        {trackingUrl && (
          <>
            <Button color="primary" variant="contained">
              <CustomLink
                href={trackingUrl}
                target="_blank"
                rel="noreferrer noopener"
              >
                Voir le suivi transporteur
              </CustomLink>
            </Button>
          </>
        )}
        <Button color="primary" variant="contained">
          <CustomLink
            href={getUrl(currentCommand.randomId)}
            target="_blank"
            rel="noreferrer noopener"
          >
            Voir le suivi Sympl
          </CustomLink>
        </Button>
      </ButtonContainer>
    </div>
  );
};

const mapStateToProps = state => ({
  currentCommand: state.commands.currentCommand
});

Tracking.propTypes = {
  currentCommand: PropTypes.object.isRequired
};

export default connect(mapStateToProps)(Tracking);
